
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';


import { ErrorPageComponent } from "./error-page";
import { MainPageComponent } from "./main-page";
import { ErrorState ,MainState} from './states';
import {AppUiModule} from "../ui";
import {AppComponent} from "./app";

let STATES = [ ErrorState, MainState];

/** The NgModule for the Core feature */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UIRouterModule.forChild({ states: STATES }),
        AppUiModule
    ],
    declarations: [
        ErrorPageComponent,
        MainPageComponent,
        AppComponent
    ],
    bootstrap:[]
})
class AppCoreModule {}

export {AppCoreModule};